import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { Notification as NotificationComp } from '@vds/notifications';

// import './notification.css';

import logger from '../ErrorBoundary/logger_new';
import { propsVal, defaultPropsVal } from './commonHelper';
import { eventDispatcher } from '../Tagging/index';

const Notification = (props) => {
  useEffect(() => {
    const { serviceInfo, log, type } = props;
    if (props.pageName === 'tosIndex') {
      logSendData();
    }

    if (serviceInfo && log && type === 'error') {
      logNotification();
    }
  }, [props.serviceInfo]);

  const logSendData = () => {
    const svarsObj = {
      evar13: 'you can proceed after you accept the Terms of Service & Customer Agreement',
      evar22: 'message displayed',
    };
    eventDispatcher('sendData', {
      name: '',
      svars: svarsObj,
    });
  };

  const logNotification = () => {
    const { children, logService, disableVideoAssist } = props;

    if (children) {
      const elem = document.createElement('div');
      elem.innerHTML = ReactDOMServer.renderToStaticMarkup(children);
    }
    logger({
      message: props.title,
      eventType: 'FeError',
      networkError: logService ? props.serviceInfo : undefined,
      errorName: '',
      notification: true,
      note: props.note,
      disableVideoAssist,
    });
  };

  return (
    <NotificationComp
      type={props.type}
      title={props.title}
      subtitle={props.subtitle}
      hideCloseButton={props.hideCloseButton}
      disableAnimation={props.disableAnimation}
      fullBleed={props.fullBleed}
      // className={props.className}
      onCloseButtonClick={props.onCloseButtonClick}
      buttonData={props.buttonData}
      layout={props.layout}
    />
  );
};

const valOfProps = propsVal();
const valOfDefaultProps = defaultPropsVal();

Notification.defaultProps = {
  ...valOfDefaultProps,
};

Notification.propTypes = {
  ...valOfProps,
};

const mapStateToProps = (state, ownProps) => ({
  serviceInfo: state?.serviceInfo || ownProps.serviceInfo,
});

const withConnect = connect(mapStateToProps);

const NotificationWrapper = withRouter(compose(withConnect)(Notification));

export default NotificationWrapper;
